import axios from 'axios';

const axiosInstance = axios.create({
    baseURL:
        process.env.NODE_ENV === 'development'
            ? '/backend/'
            : 'https://clearrentorg.net/backend/',
    // baseURL: 'http://localhost:5010',
    timeout: 30000, // Set timeout to 30 seconds
});

// Request interceptor to add Authorization header
axiosInstance.interceptors.request.use(
    function (config) {
        try {
            const tokenItem = localStorage.getItem('token');
            if (tokenItem) {
                // Try to parse as JSON first, if it fails, use as plain string
                let token;
                try {
                    token = JSON.parse(tokenItem);
                } catch (e) {
                    // If parsing fails, it's already a plain string
                    token = tokenItem;
                }
                if (token) {
                    // config.headers['Authorization'] = `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6ImRiYmI1MzE1LTk4ZjAtNDc5Yi04NTJhLWNiOWFiOGViMDA2YyIsImlhdCI6MTcyNjczMzMyOSwiZXhwIjoxNzI5MzI1MzI5fQ.qMuc1_7mrbz0AkbTNTxmNLLPFkD1UXrRfcqlS6NfiI4`;
                    config.headers['Authorization'] = `Bearer ${token}`;
                }
            }
        } catch (error) {
            console.error('Error getting token from localStorage:', error);
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

const localVersion = localStorage.getItem('frontend_version');
axiosInstance.interceptors.response.use(
    function (response) {
        // console.log('response?.headers?.Frontend_version1',response.headers.get('frontend_version'));
        // console.log('response?.headers?.Frontend_version2',response.headers.get('frontend_version'));
        const frontendVersion = response.headers.get('frontend_version');
        if (frontendVersion) {
            localStorage.setItem('frontend_version', frontendVersion);
        }
        
        if (localVersion === frontendVersion) {
            return response;
        } else if (localVersion == null || localVersion == undefined || localVersion == 'undefined' || localVersion == 'null') {
            return response;
        } else {
            localStorage.clear();
            window.location.href = '/login';
            return response; // Return response even when redirecting
        }
    },
    function (error) {
        // Don't redirect to login for public share / start-call endpoints - allow unauthenticated view
        const requestUrl = error?.config?.url || '';
        const isPublicShareRequest = typeof requestUrl === 'string' && requestUrl.includes('/property/share/');
        const isStartCallRequest = typeof requestUrl === 'string' && requestUrl.includes('/screening/start-call');
        if (error?.response?.status === 401 && !isPublicShareRequest && !isStartCallRequest) {
            // Unauthorized - clear storage and redirect to login
            localStorage.clear();
            window.location.href = '/login';
        }
        // else{
        //     toast.error(error?.response?.data?.message)
        // }
        return Promise.reject(error);
    }
);

export default axiosInstance;
